__turbopack_context__.v({
  "back": "mouse-module__p_CFmq__back",
  "description": "mouse-module__p_CFmq__description",
  "flex": "mouse-module__p_CFmq__flex",
  "heading": "mouse-module__p_CFmq__heading",
  "headingIcon": "mouse-module__p_CFmq__headingIcon",
  "mouse": "mouse-module__p_CFmq__mouse",
  "shell": "mouse-module__p_CFmq__shell",
  "title": "mouse-module__p_CFmq__title",
});
